import React from "react";
import { Sparklines, SparklinesLine } from "react-sparklines";

const SparkLineGraph = ({
    data,
    width = 100,
    height = 20,    
    style = { strokeWidth: 1, fill: "none" },
    className = ""
}) => {

    const measuredColor = getComputedStyle(document.documentElement).getPropertyValue('--brand-yellow').trim();

    const sanitized =
        Array.isArray(data) && data.length
            ? data
                .map((d) => Number(d))
                .filter((n) => !Number.isNaN(n))
            : [];

    if (!sanitized.length) return null;

    return (
        <div className={className}>
            <Sparklines data={sanitized} width={width} height={height}>
                <SparklinesLine color={measuredColor} style={style} />
            </Sparklines>
        </div>
    );
};

export default SparkLineGraph;
